import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';

import './style.css';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';

import {
    MemberTabDetails, ResponseMemberTabDetails, RequestMembersRegistryFirstTabUpdate,
    MembersRegistryError, RequestMembersRegistryFirstTab, MembersTabInfo,
    RequestMembersRegistrySecondTab, RequestMembersRegistryThirdTab,
    ResponseDepartment, ResultCivilStatus
} from '../../interface/IMembersRegistry';
import { Response, ApiResponse } from '../../interface/IResponse';

import membersRegistryService from './membersRegistryService';

import SuccessModal from '../../components/Modal/SuccessModal';

import DatePicker from "react-datepicker";

import helpers from '../../helpers/index';
import { useStepContext } from '@mui/material';



function ViewMember() {

    var dispatch = useDispatch();
    const navigate = useNavigate();

    const [isReadOnly, setIsReadOnly] = useState(false);
    const defaultMemberTabDetails: MemberTabDetails = {
        membershipId: '',
        departmentId: 0,
        firstname: '',
        middlename: '',
        lastname: '',
        taxIDNo: '',
        username: '',
        email: '',
        contactNo: '',
        address: '',
        dateOfBirth: null,
        age: '',
        gender: '',
        civilStatus: 0,
        educationalAttainment: '',
        religion: '',
        occupation: '',
        annualIncome: '',
        numberOfDependents: '',
        dateAccepted: null,
        dateOfSeparation: null,
        bodResNo: '',
        membershipType: '',
        amountSubscribe: '',
        initialPaidAmount: ''
    };


    const [memberTabDetails, setMemberTabDetails] = useState<MemberTabDetails>(defaultMemberTabDetails);
    const [department, setDepartment] = useState("");
    const [civilStatusText, setCivilStatusText] = useState("");

    const memberId = useParams<{ memberId: string; }>();

    const dateAccepted = memberTabDetails.dateAccepted ? new Date(memberTabDetails.dateAccepted) : null;
    const dateOfBirth = memberTabDetails.dateOfBirth ? new Date(memberTabDetails.dateOfBirth) : null;
    const dateOfSeparation = memberTabDetails.dateOfSeparation ? new Date(memberTabDetails.dateOfSeparation) : null;


    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    async function getDepartment(departmentId: number) {

        try {
            if (departmentId > 0) {


                var response: AxiosResponse<ResponseDepartment> = await membersRegistryService.getDepartmentById(departmentId);

                setDepartment(response.data.result.departmentName);
            }
            else {
                setDepartment("");
            }
        }
        catch (err) {

            console.log('getDepartment:: ', err);
            throw err;
        }

    }

    async function getMemberTabDetails() {
        try {
            var response: AxiosResponse<ResponseMemberTabDetails> = await membersRegistryService.getMemberDetailsTab(Number(memberId.memberId));

            var memberTabDetails = response.data.result;


            setMemberTabDetails(memberTabDetails);

            await getDepartment(Number(response.data.result.departmentId));

            await loadCivilStatusByValue(Number(memberTabDetails.civilStatus));

        }
        catch (err) {
            console.log('getMemberTabDetails:: ', err);
            throw err;

        }
    }

    function formatDate(date: Date | null | undefined): string {
        if (!date) return ''; // Handle null or undefined case

        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
        const formatter = new Intl.DateTimeFormat('en-US', options);
        return formatter.format(date);
    }

    function cancelButtonClick() {
        navigate('/Admin/MembersRegistry');
    }

    function editButtonClick() {
        navigate('/Admin/UpdateMember/' + memberId.memberId);
    }

    async function loadCivilStatusByValue(value: number) {
        try {
            var axiosResponse = await membersRegistryService.getCivilStatusByValue(value);
            var response: ApiResponse<string> = axiosResponse.data;

            setCivilStatusText(response.result);
        }
        catch (err) {
            console.log(err);
        }
    }



    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await getMemberTabDetails();
            getPermission();
            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);


    return (<Layout>
        <div className="title-container">
            <div className="dv-title">
                <div>
                    <h1>{memberTabDetails.firstname} {memberTabDetails.middlename} {memberTabDetails.lastname}</h1>
                    <div>
                        <label className="label-2">Membership Id:</label> <label className="label-3">#{memberTabDetails.membershipId}</label>
                    </div>
                    <div>
                        <label className="label-2">Username:</label>  <label className="label-3">{memberTabDetails.username}</label>
                    </div>
                </div>


            </div>
            <div className="title-btn-container vertical-flex-bottom">

                <button type="button" id="btnBack"
                    onClick={cancelButtonClick}
                    className="btn-white-green-2 center-middle">Back</button>

                <button type="button" id="btnEdit"
                    disabled={isReadOnly}
                    className="btn-green-2 center-middle"
                    onClick={editButtonClick}
                >Edit</button>

            </div>
        </div>
        <br />
        <div className='content-container'>
            <div className='padding-container'>
                <div style={{ display: "flex", width: "100%" }} className='details-container'>

                    <div style={{ width: '48%' }} className='details-inner'>

                        <div>
                            <label className="label-2">Fullname:</label> <label className="label-3">{memberTabDetails.firstname} {memberTabDetails.lastname}</label>
                        </div>

                        <div>
                            <label className="label-2">Email:</label> <label className="label-3">{memberTabDetails.email}</label>
                        </div>

                        <div>
                            <label className="label-2">Contact No:</label> <label className="label-3">{memberTabDetails.contactNo}</label>
                        </div>
                    </div>
                    <div style={{ width: '48%' }} className='details-inner'>

                        <div>
                            <label className="label-2">Date Accepted:</label> <label className="label-3">{formatDate(dateAccepted)}</label>
                        </div>

                        <div>
                            <label className="label-2">Verification Status:</label> <label className="label-3">{memberTabDetails.verificationStatus ? "Verified" : "Unverified"}</label>
                        </div>

                        <div>
                            <label className="label-2">Account Status:</label> <label className="label-3">{memberTabDetails.accountStatus ? "Complete" : "Incomplete"}</label>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <br />
        <div className='content-container'>
            <div className='padding-container'>
                <div>
                    <div className='title'>Full Member Info</div>
                </div>
                <div style={{ display: "flex", width: "100%" }} className='details-container'>
                    <div style={{ width: '48%' }} className='details-inner'>

                        <div>
                            <label className="label-2">Department:</label> <label className="label-3">{department}</label>
                        </div>

                        <div>
                            <label className="label-2">First Name:</label> <label className="label-3">{memberTabDetails.firstname}</label>
                        </div>

                        <div>
                            <label className="label-2">Middle Name:</label> <label className="label-3">{memberTabDetails.middlename}</label>
                        </div>



                        <div>
                            <label className="label-2">Last Name:</label> <label className="label-3">{memberTabDetails.lastname}</label>
                        </div>

                        <div>
                            <label className="label-2">Email:</label> <label className="label-3">{memberTabDetails.email}</label>
                        </div>

                        <div>
                            <label className="label-2">Contact No:</label> <label className="label-3">{memberTabDetails.contactNo}</label>
                        </div>


                        <div>
                            <label className="label-2">Address:</label> <label className="label-3">{memberTabDetails.address}</label>
                        </div>

                        <div>
                            <label className="label-2">Date of Birth:</label> <label className="label-3">{formatDate(dateOfBirth)}</label>
                        </div>

                        <div>
                            <label className="label-2">Age:</label> <label className="label-3">{memberTabDetails.age}</label>
                        </div>

                        <div>
                            <label className="label-2">Gender:</label> <label className="label-3">{memberTabDetails.gender}</label>
                        </div>

                        <div>
                            <label className="label-2">Civil Status:</label> <label className="label-3">{civilStatusText}</label>
                        </div>

                        <div>
                            <label className="label-2">Religion:</label> <label className="label-3">{memberTabDetails.religion}</label>
                        </div>
                    </div>
                    <div style={{ width: '48%' }} className='details-inner'>
                        <div>
                            <label className="label-2">Tax ID No:</label> <label className="label-3">{memberTabDetails.taxIDNo}</label>
                        </div>

                        <div>
                            <label className="label-2">Number of Dependents:</label> <label className="label-3">{memberTabDetails.numberOfDependents}</label>
                        </div>
                        <div>
                            <label className="label-2">Occupation:</label> <label className="label-3">{memberTabDetails.occupation}</label>
                        </div>

                        <div>
                            <label className="label-2">Annual Income:</label> <label className="label-3">{memberTabDetails.annualIncome}</label>
                        </div>

                        <div>
                            <label className="label-2">Educational Attainment:</label> <label className="label-3">{memberTabDetails.educationalAttainment}</label>
                        </div>

                        <div>
                            <label className="label-2">Date Accepted:</label> <label className="label-3">{formatDate(dateAccepted)}</label>
                        </div>

                        <div>
                            <label className="label-2">Date of Separation:</label> <label className="label-3">{formatDate(dateOfSeparation)}</label>
                        </div>

                        <div>
                            <label className="label-2">BOD Res No:</label> <label className="label-3">{memberTabDetails.bodResNo}</label>
                        </div>

                        <div>
                            <label className="label-2">Membership Type:</label> <label className="label-3">{memberTabDetails.membershipType}</label>
                        </div>

                        <div>
                            <label className="label-2">Amount Subscribed:</label> <label className="label-3">{memberTabDetails.amountSubscribe}</label>
                        </div>

                        <div>
                            <label className="label-2">Capital Shares:</label> <label className="label-3">{memberTabDetails.initialPaidAmount}</label>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>);
}


export default ViewMember;